import React from 'react';

export default (props) => (
  <div className="question-accordion-content">
    <div className="question-accordion-content-holder">

      <p className="question-accordion-content-text">How do you feel about the use of written <span className="bold">communication conventions</span> when working via text with your client?
        You may have grown up using them, or discovered them already, or this lesson may be complete news to you!
      </p>

      <ul className="file-list editing">
        <li className="file-item">
          <i className="file-icon ic-file-ico"/>
          <div className="file-link">
            <a className="file-link-active">Family Interventions.doc</a>
            <span className="file-link-size">454 KB</span>
          </div>
          <span className="file-delete">
              <i className="ic-close-ico"/>
            </span>
        </li>
        <li className="file-item">
          <i className="file-icon ic-file-ico"/>
          <div className="file-link">
            <a className="file-link-active">Family Interventions.doc</a>
            <span className="file-link-size">454 KB</span>
          </div>
          <span className="file-delete">
              <i className="ic-close-ico"/>
            </span>
        </li>
        <li className="file-item">
          <i className="file-icon ic-file-ico"/>
          <div className="file-link">
            <a className="file-link-active">Family Interventions.doc</a>
            <span className="file-link-size">454 KB</span>
          </div>
          <span className="file-delete">
              <i className="ic-close-ico"/>
            </span>
        </li>
      </ul>

    </div>

    <div className="answers">
      <div className="answer-item">
        <div className="answer-item-head">
          <div className="answer-item-avatar">
            <img src="../" alt="avatar"/>
          </div>
          <div className="answer-item-info">
            <p className="name">Alexandra Voroshilova</p>
            <p className="type">Response Posted</p>
          </div>
          <div className="answer-item-date">23 SEP 16:34</div>
        </div>
        <div className="answer-item-content">
          <div className="answer-item-content-holder">
            <p className="answer-item-text">While using text as a form of communication I feel
              its best to err on the side of caution with a client. While the
              approach of the client may relax (or they may be relaxed from the
              beginning) it is the responsibility of the therapist to
              maintain a level of professionalism. This professionalism can help
              to create the separateness necessary for effective
              therapy. While I didn't grow up using modern text conventions I have
              been familiar with them for close to two
              decades now. I find the use of emojis/emoticons quite useful in communicating
              the tone of a message such as a
              winky face ;) to confirm a joke. I find however the over use of these can
              lead to confusion especially with double
              meanings of some symbols. Professionally I would see the use of some simple
              symbols as acceptable as long as
              this mirrored the behavior of the client however this would come with limitations.
              A message to the client explaining their limited use could prove helpful
            </p>
            <span className="border"/>
            <ul className="file-list">
              <li className="file-item">
                <i className="file-icon ic-file-ico"/>
                <div className="file-link">
                  <a className="file-link-active">Family Interventions.doc</a>
                  <span className="file-link-size">454 KB</span>
                </div>
              </li>
              <li className="file-item">
                <i className="file-icon ic-file-ico"/>
                <div className="file-link">
                  <a className="file-link-active">Family Interventions.doc</a>
                  <span className="file-link-size">454 KB</span>
                </div>
              </li>
              <li className="file-item">
                <i className="file-icon ic-file-ico"/>
                <div className="file-link">
                  <a className="file-link-active">Family Interventions.doc</a>
                  <span className="file-link-size">454 KB</span>
                </div>
              </li>
            </ul>
            <div className="answer-item-edit btn-holder">

              <span className="btn bordered empty grey-empty">edit</span>
            </div>
          </div>
        </div>
      </div>
      <div className="answer-item feedback">
        <div className="answer-item-head">
          <div className="answer-item-avatar">
            <img src="../img/card-ava.jpg" alt="avatar"/>
          </div>
          <div className="answer-item-info">
            <p className="name">Alexandra Voroshilova</p>
            <p className="type">Response Posted</p>
          </div>
          <div className="answer-item-date">23 SEP 16:34</div>
        </div>
        <div className="answer-item-content">
          <div className="answer-item-content-holder">
            <p className="answer-item-text">While using text as a form of communication I feel
              its best to err on the side of caution with a client.</p>
          </div>
        </div>
      </div>
    </div>

    <div className="btn-holder">
      <span className="btn prime bordered">add response</span>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/blocks/questions/QuestionContent.jsx